import { configureStore } from "@reduxjs/toolkit";
import  combineReducer  from "./slices/PaymentSlice";
import posts from './apiCalls/calenderApiCall'
import pay from './slices/paySlice'
import order from './slices/OrderSlice'
import Cuppon from './slices/CupponSlice'
import Price from './slices/PriceSlice';
import images from "./slices/PagesSlice";
import contact from "./slices/ContactUs";
import pages from "./slices/PagesAllSlice"
import success from './slices/successSlice'

const store = configureStore({
  reducer: {
    combined: combineReducer,
    posts,
    pay,
    order,
    Cuppon,
    Price,
    images,
    contact,
    pages,
    success
  },
});

export default store;
